module.exports = "<main role=main> <div class=main-col> <h1 class=panel-title translate>nav.forbidden</h1> <p translate> app.forbidden </p> </div> </main> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/auth/forbidden.html
// module id = 541
// module chunks = 0